<template>
  <div class="header">
    <div class="container">
      <div class="logo" v-if="logo.LOGO_PATH === ''">
        <a href="" :title="logo.LOGO_TITLE">
          <!-- :src='$store.getters.sysConfigs.LOGO_PATH' -->
          <img :src="logo.LOGO_IMG" style="width:50px" alt=""><span>{{logo.LOGO_TITLE}}</span>
        </a>
      </div>
      <div class="logo" v-else>
        <img :src="logo.LOGO_PATH" :title="logo.LOGO_TITLE">
      </div>
      <div class="menubtn" :class="{active:act == false}" @click="show()">
        <span class="span1"></span>
        <span class="span2"></span>
        <span class="span3"></span>
      </div>
      <div class="menubth-shad" :class="{active:act == false}" @click="show()"></div>
      <div class="nav" :class="{active:act == false}" @click="show()">
        <ul>
          <li
            v-for="menu in headerMenus"
            :key="`header-menu-${menu.index}`"
            >
            <a
            :class="{active:active===menu.indexText}"
            :href="menu.href">{{menu.name}}</a>
          </li>
          <!-- <li><a :class="{active:actives == 1}" @click="active(1)" href="/">首页</a></li> -->
          <!-- <li><a :class="{active:actives == 2}" @click="active(2)" href="/">关于我们</a></li> -->
          <!-- <li><a href="">网站优化</a></li> -->
          <!-- <li><a href="">整站优化</a></li> -->
          <!-- <li><a href="">SEO技术</a></li> -->
          <!-- <li><a href="">成功案例</a></li> -->
          <!-- <li><a href="">新闻资讯</a></li> -->
          <!-- <li><a href="">联系我们</a></li> -->
          <!-- <li><a href="">全国分站</a></li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['active'],
  data () {
    return {
      act: true,
      logo: [],
      headerMenus: []
    }
  },
  mounted () {
    // this.logo = require('../../static/configes/configes.json')
    // console.log(1234)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.headerMenus = response.data.HEADER_MENUS
        this.logo = response.data.LOGO
        // console.log(this.logo)
      })
  },
  methods: {
    show: function () {
    // console.log(this.act)
      this.act = !this.act
      if (this.act) {
        this.act = true
      } else {
        this.act = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  background-color: #fff;
  color: #5a5a5a;
  height: 100px;
  line-height: 80px;
  position: fixed;
  width: 100%;
  padding: 15px 0 15px 0;
  top: 0;
  z-index: 11;
  transform: 0.4 all;
  .container {
    width: 96%;
    max-width: 1200px;
    margin: 0 auto;
    .logo {
      width: 45%;
      float: left;
      a {
      color: #5a5a5a;
      display: block;
      }
      img {
        border: none;
        vertical-align: middle;
        max-width: 100%;
        height: 50px;
        // width: 50px;
        margin-right: 10px;
      }
      span {
        font-size: 23px;
      }
    }
    @media only screen and (max-width: 900px){
      .logo span {
        display: none;
      }
      .menubth-shad.active {
      width: 100%;
      height: 0;
      position: fixed;
      top: 50%;
      left:50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.7);
      transition: 0.3s all;
    }
      .menubth-shad.active {
        height: 100%;
      }
      .header {
        height: 60px;
        line-height: 60px;
      }
      .menubtn {
        display: block;
      }
      .menubtn.active {
        right: 220px;
        span.span1 {
          transform-origin: 100% 50%;
          transform: rotate(-43deg)
        }
        span.span2 {
          opacity: 0;
          transform: translate(80px);
        }
        span.span3 {
          transform-origin: 100% 50%;
          transform: rotate(43deg)
        }
      }
      .nav {
        width: 200px;
        background: rgba(49, 152, 242, .8);
        position: fixed;
        height: 100%;
        overflow: auto;
        top: 0;
        right: -200px;
        transition: 0.6s all;
        ul li {
          display: block;
          line-height: 45px;
          a {
            color: #fff;
            border-bottom: solid 1px #378fdd;
            // line-height: normal;
            padding: 12px 0;
          }
          a.active {
            color: #fff;
            border: none;
            border-bottom: solid 1px #429ae9;
            opacity: 1;
          }
        }
      }
      .nav.active {
        right: 0;
      }
    }
    @media only screen and (min-width: 1199px){
      .logo span {
        display: initial;
      }
      .nav ul li {
        color: #5a5a5a;
        display: inline-block;
        line-height: 60px;
        a {
          color: #000;
          font-size: 18px;
          // font-weight: 600;
        }
      }
      .header {
        height: 80px;
        line-height: 80px;
      }
      .menubtn {
        display: none;
      }
    }
    // @media screen and (max-width: 1199px){
    //   .nav ul li {
    //     display: inline-block;
    //     line-height: 60px;
    //   }
    //   .header {
    //     height: 80px;
    //     line-height: 80px;
    //   }
    //   .menubtn {
    //     display: none;
    //   }
    // }
    @media screen and (min-width:900px) and (max-width: 1199px){
      .logo a span {
        display: initial;
      }
      .menubth-shad.active {
      width: 100%;
      height: 0;
      position: fixed;
      top: 50%;
      left:50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.7);
      transition: 0.3s all;
    }
      .menubth-shad.active {
        height: 100%;
      }
      .header {
        height: 60px;
        line-height: 60px;
      }
      .menubtn {
        display: block;
      }
      .menubtn.active {
        right: 220px;
        span.span1 {
          transform-origin: 100% 50%;
          transform: rotate(-43deg)
        }
        span.span2 {
          opacity: 0;
          transform: translate(80px);
        }
        span.span3 {
          transform-origin: 100% 50%;
          transform: rotate(43deg)
        }
      }
      .nav {
        width: 200px;
        background: rgba(49, 152, 242, .8);
        position: fixed;
        height: 100%;
        overflow: auto;
        top: 0;
        right: -200px;
        transition: 0.6s all;
        ul li {
          display: block;
          line-height: 45px;
          a {
            color: #fff;
            border-bottom: solid 1px #378fdd;
            // line-height: normal;
            padding: 12px 0;
          }
          a.active {
            color: #fff;
            border: none;
            border-bottom: solid 1px #429ae9;
            opacity: 1;
          }
        }
      }
      .nav.active {
        right: 0;
      }
    }
    .menubtn {
      position: fixed;
      right: 20px;
      top: 40px;
      width: 32px;
      text-align: center;
      cursor: pointer;
      z-index: 100;
      // display: none;
      transition: 0.4s all;
      span {
        display: block;
        width: 100%;
        height: 3px;
        background: #5a5a5a;
        margin-bottom: 8px;
        transition: 0.3 all;
      }
    }
    .nav {
      // width: 75%;
      // float: left;
      ul {
        text-align: center;
        li {
          // line-height: 60px;
          // display: inline-block;
          a {
            transition: all .3s ease-in-out;
            padding: 0px 12px;
            // color: #5a5a5a;
            opacity: 0.7;
            display: block;
          }
          a.active {
            border-bottom: solid 2px #949494;
            opacity: 1;
            display: block;
          }
          a:hover {
            border-bottom: solid 2px #949494;
            opacity: 1;
            display: block;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue